export const formatAsCurrency = function (value) {
  // 1) Define options for the formatter
  const options = {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  };

  // 2) Return formatted value
  return new Intl.NumberFormat('en-US', options).format(value);
};

export const formatAsNumber = function (value) {
  // 1) Return value in American format
  return new Intl.NumberFormat('en-US').format(value);
};
